import React from 'react';
import { MenuItem, MenuSeparator } from '../components/Menu';
import templateIcon from '../icons/non-prefilled/16x16/template.svg';
import useIsLayoutSize from '../post/utils/useIsLayoutSize';
import { LayoutSize } from '../post/utils/useLayoutSize';
import TemplateRow from './TemplateRow';
import * as styles from './TemplatesMenuItem.module.scss';
import useTemplatesSections from './useTemplatesSections';

// eslint-disable-next-line import/no-unused-modules -- expose for testing
export const TemplatesMenuItemSubmenu = () => {
  const templatesSections = useTemplatesSections({
    totalLimit: 10,
    sectionLimit: 5,
  });

  return (
    <div className={styles.submenu}>
      {templatesSections.map((section) => (
        <React.Fragment key={section.title}>
          <div className={styles.header}>{section.title}</div>
          {section.templates.map((template) => (
            <TemplateRow
              key={'id' in template ? template.id : template.title}
              template={template}
              padding="small"
              showHoverCard
            />
          ))}
          <MenuSeparator />
        </React.Fragment>
      ))}
      <MenuItem to="/templates">View all templates</MenuItem>
    </div>
  );
};

const TemplatesMenuItem = () => {
  const isMobile = useIsLayoutSize(LayoutSize.mobile);

  return (
    <MenuItem
      icon={templateIcon}
      to={isMobile ? '/templates' : undefined}
      submenuItems={isMobile ? undefined : <TemplatesMenuItemSubmenu />}
    >
      Templates
    </MenuItem>
  );
};

export default TemplatesMenuItem;
